<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8" lg="6">
          <b-card no-body class="p-4">
            <b-card-body>
              <h1> Reset your password </h1>
                <p class="text-muted">
                  <span>When the password is reset, the existing OTP will be initialized.</span>
                </p>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                <input :disabled="reset || lock_btn" type="text" class="form-control" placeholder="Username" v-model="model.username" @keyup.enter="otpToken()">
                <b-button :disabled="reset || lock_btn" variant="secondary" class="px-4" @click="otpToken()">Submit</b-button>
              </b-input-group>
              <b-input-group class="mb-3" v-if="reset">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <input type="password" class="form-control" placeholder="new password" v-model="model.password_new">
              </b-input-group>
              <b-input-group class="mb-3" v-if="reset">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <input type="password" class="form-control" placeholder="new password repeat" v-model="model.password_new_repeat" @keyup.enter="newPassword()">
              </b-input-group>
              <hr v-if="reset && model.password_new">
              <small v-if="reset">
                <b-badge v-if="model.password_new"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('length') ? 'success' : 'danger'">
                  Min Length : 10
                </b-badge>
              </small>
              <hr>

              <b-button v-if="reset" variant="primary" class="form-control" @click="newPassword()">Submit</b-button>
              <b-button class="float-left" variant="link" @click="$router.push({ name: 'auth_login'})">Sign in</b-button>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { Api } from '@/service';
import * as forge from 'node-forge'
import * as _ from 'lodash'
import reg from '@/reg'

export default {
  data: function () {
    return {
      checked: false,
      error: '',
      model: { username: '', password: '' },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
      lock: false,
      lock_btn : false,
      reset : false
    }
  },
  computed: {
    // ts() { return this.$ts(wordset, this.$store.getters.lang) }
  },
  methods: {
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.password_new && reg.reg_number.test(this.model.password_new) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.password_new && reg.reg_alphabat_upper.test(this.model.password_new) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.password_new && reg.reg_alphabat_lower.test(this.model.password_new) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.password_new && reg.reg_spacial.test(this.model.password_new) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.password_new && this.model.password_new.length >= 10) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    otpToken: function () {
      this.error = '';
      if(_.isEmpty(this.model.username)) { return this.$toastr.e('Plz, Typing email'); }
      if(!reg.email.test(this.model.username)) { return this.$toastr.w('typing was not email format');}

      this.model.url = location.hostname == 'localhost' ? `${location.protocol}//${location.host}/#/auth/reset` : `${location.protocol}//${location.hostname}:${location.port}/#/auth/reset`
      this.lock = true;
      this.lock_btn = true;
      Api.auth.tokenReset(this.model).then((rs) => {
        if(!rs) { return this.$toastr.e("request sending email", "failed"); }
        setTimeout(() => {
          this.lock_btn = false;
        }, 3 * 60 * 1000);
        this.$toastr.i('Auth token expire later 3 min', "check your inbox");
      }).catch(e => { console.log(e); this.lock_btn = false; this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});
    },
    otpVerify: async function (token = this.$route.query.token, username = this.$route.query.username) {
      // console.log("token", token, 'username', username)
      if(username) { this.model.username = username }
      if(!token) { return; }
      try {
        let rs = await Api.auth.tokenVerify({ token : token });
        if(!rs) {
          this.$toastr.e("expired", "not allowed, try request auth email again")
        } else {
          if(username) { this.model.username = username }
          this.reset = true; return this.$toastr.i('Authorize successfully', 'done');
        }
      } catch (e) {
        // 토큰이 유효하지 않을 경우 에러 발생
        // 패스워드 찾기 프로세스 진행
        alert("So nice again visit to us.\n\nThe initialization procedure must be performed again. \n\n Start from the beginning ! ")
        this.$router.push({ name: 'auth_reset', query : { username : username } });
        this.$e
      }
    },
    newPassword: function () {
      if(_.isEmpty(this.model.password_new)) { return this.$toastr.e('Typing new password'); }
      if(_.isEmpty(this.model.password_new_repeat)) { return this.$toastr.e('Typing new password repeat'); }
      if(this.model.password_new_repeat != this.model.password_new) { return this.$toastr.e('not same password and password repeat'); }

      if(this.model.new_password) {
        var rs = this.password_policy('all')
        if(rs.is_error) {
          var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
          return this.$toastr.e(`Please check password policy [${msg}]`);
        }
      }


      let user = {
        username : this.model.username,
        token : this.$route.query.token,
        new_password : forge.sha256.create().update(this.model.password_new).digest().toHex() // salt update
      }
      Api.auth.ResetPassword(user).then(() => {
        alert("changed successfully");
        this.$router.push({ name: 'auth_login' });
      }).catch(e => {
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText);
        this.model.password_new_repeat = "";
        this.model.password_new = "";
        this.model.password = "";
        this.lock = false;
      })
    },
    format(val, event) {
      if(!event) { return val; }
      let rs = val.replace(/-/g, '')
      if(rs.length <= 3) { return `${rs.substring(0, 3)}` }
      else if(rs.length <= 5) { return `${rs.substring(0, 3)}-${rs.substring(3, 5)}` }
      else { return `${rs.substring(0, 3)}-${rs.substring(3, 5)}-${rs.substring(5, 10)}` }
    },
  },

  created: function() { console.log('login.vue', 'created'); },
  destroyed: function() { console.log('login.vue', 'destroyed'); },
  mounted: function() {
    console.log('login.vue mounted');
    if(window.localStorage.getItem('username')) { this.checked = true; this.model.username = window.localStorage.getItem('username'); }
    this.otpVerify()

  }
}

</script>
